import React, { useMemo } from "react"
import { Box, useTheme } from "@mui/material"

import { getIcon } from "utils/icon"

import { useTranslation } from "providers/i18n"
import { Head } from "components/Head"
import { EmptyData } from "components/EmptyData"
import { CalendarStarIcon } from "components/icons"
import { Link } from "react-router-dom"
import { PageLayout } from "extensions/iconsiam/layouts/PageLayout"
import { Header } from "extensions/iconsiam/components/Header"
import { useEvent } from "extensions/iconsiam/hooks/event/useEvent"
import { VenueFilterBar } from "extensions/iconsiam/components/VenueFilterBar"
import { VerticalEventCard } from "extensions/iconsiam/components/domains/events"
import { HeaderSearchButton } from "extensions/iconsiam/components/Header/HeaderSearchButton"

export const Events = ({ Layout = PageLayout }) => {
  const { t } = useTranslation()
  const { venueFilter, events, changeVenueFilter } = useEvent()

  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.events) || <CalendarStarIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`EventPage`] || {}
  const { root, gridContainer, emptyDataWrapper } = styleOverrides

  return (
    <>
      <Head title={t("Events & Activities")} />
      <Layout
        header={
          <Header
            filterBar={
              <VenueFilterBar
                onClickVenue={changeVenueFilter}
                value={venueFilter}
              />
            }
            searchButton={<HeaderSearchButton />}
          />
        }
      >
        <Box sx={root}>
          {events && events.length > 0 ? (
            <Box sx={gridContainer}>
              {events.map((event) => {
                const sponsoredId = event?.properties?.sponsoredId
                return (
                  <Link
                    to={`/events/${event.id}`}
                    key={`${sponsoredId || ""}${event.id}`}
                  >
                    <VerticalEventCard event={event} />
                  </Link>
                )
              })}
            </Box>
          ) : (
            <Box sx={emptyDataWrapper}>
              <EmptyData
                icon={emptyIcon}
                primary={t(`Coming Soon`)}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </Box>
      </Layout>
    </>
  )
}
